<template>
    <div class="personal-center">
        <van-nav-bar
                title="个人中心"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
        />
        <div class="personal-inner">
            <div class="user_info">
                <van-image
                        round
                        width="60px"
                        height="60px"
                        :src="form.headimgurl"
                />
                <div class="user_name">{{form.name}}</div>
            </div>
            <div class="user_center">
                <div class="center_list">
                    <div class="center_item" v-for="(item,index) in centerList" :key="index" @click="goItem(item.link)">
                        <div class="item-left">
                            <img class="title_icon" :src="item.icon" alt="">
                            <div>{{item.title}}</div>
                        </div>
                        <img class="personal_right_arrow_icon" src="@/assets/personal_right_arrow_icon.png" alt="">
                    </div>
                </div>
            </div>
        </div>
      <div class="school_logo"><img src="@/assets/form_logo.png" alt=""></div>
    </div>
</template>

<script>
import {weixinInfo} from '../../utils/ajaxInterface'
export default {
  name: 'center',
  data () {
    return {
      form: {},
      centerList: [
        {icon: require('../../assets/personal_biaoqian.png'), title: '个人信息', link: '/personalInfor'},
        {icon: require('../../assets/donation_biaoqian.png'), title: '我的捐赠单', link: '/myDonation'}
      ]
    }
  },
  created () {
    this.getWeixinName()
  },
  methods: {
    getWeixinName () {
      weixinInfo().then(res => {
        this.form = res
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    onClickLeft () {
      this.$router.push('/map')
    },
    goItem (link) {
      this.$router.push(link)
    }
  }
}
</script>

<style scoped lang="less">
    .personal-center{
        .personal-inner{
            width: 100%;
          background-color: #F6F8FA;
          background: url("../../assets/donation_bg.png") no-repeat center top;
          background-size: 100% auto;
          /*min-height: 100vh;*/
            padding: 27px 16px 0;
            box-sizing: border-box;
            .user_info{
                display: flex;
                padding-left: 40px;
                align-items: center;
                font-size: 16px;
                color: #FFFFFF;
                margin-bottom: 14px;
                .head_img{
                    width: 48px;
                    height: 48px;
                }
                .user_name{
                    margin-left: 10px;
                }
            }
            .user_center{
                width: 100%;
                height: 326px;
                background: #FFFFFF;
                border-radius: 8px;
                padding: 0 20px;
                box-sizing: border-box;
                .center_list{
                    .center_item{
                        width: 100%;
                        height: 73px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 1px solid #D8D8D8;
                        .item-left{
                            display: flex;
                            align-items: center;
                            font-size: 14px;
                            color: #111111;
                            .title_icon{
                                width: 24px;
                                height: auto;
                                margin-right: 20px;
                            }
                        }
                        .personal_right_arrow_icon{
                            width: 9px;
                            height: 14px;
                        }
                    }
                }
            }
        }
      .school_logo{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 40px;
        width: 100%;
        height: 33px;
        text-align: center;
        img{
          width: 234px;
          height: 100%;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/personal/center.vue